<div class="horizontal-banner-list">
  <div class="banner-carousel-section" [hidden]="!banners.length">
    <h1>{{ title }}</h1>
    <owl-carousel-o
      [options]="customOptions"
      #owlCar
      (translated)="translated($event)"
      (dragging)="isDragging = $event.dragging"
    >
      @for (_banner of banners; track _banner.id) {
      <ng-template [id]="_banner.id" carouselSlide>
        <!-- Do not remove this div , will mess up the carousel -->
        <!-- https://github.com/vitalii-andriiovskyi/ngx-owl-carousel-o/issues/67 -->
        <div>
          @switch (_banner?.click_action?.action) { @case (ClickActionChoices.link_category) {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/category/' + _banner.click_action.url_path]"
            [stopLink]="isDragging"
            [queryParams]="{
              utm_source: 'home',
              utm_medium: 'banner'
            }"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.link_product) {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/products/' + _banner.click_action.url_path]"
            [queryParams]="{
              utm_source: 'home',
              utm_medium: 'banner'
            }"
            [stopLink]="isDragging"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.search_keywords) {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/search']"
            [queryParams]="{
              q: _banner.click_action.value,
              utm_source: 'home',
              utm_medium: 'banner'
            }"
            [stopLink]="isDragging"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.product_flag) {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/search']"
            [queryParams]="{
              tags: _banner.click_action.value,
              utm_source: 'home',
              utm_medium: 'banner'
            }"
            [stopLink]="isDragging"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.link_url) {
          <a class="small-banner-img-container" [href]="_banner.click_action.value" target="_blank">
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.link_collection) {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/search']"
            [queryParams]="{
              collection_ids: _banner.click_action.value,
              utm_source: 'home',
              utm_medium: 'banner'
            }"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.link_brand) {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/search']"
            [queryParams]="{
              brand_id: _banner?.click_action?.value,
              brand_name: _banner?.title,
              utm_source: 'home',
              utm_medium: 'banner'
            }"
            [stopLink]="isDragging"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } @case (ClickActionChoices.none) {
          <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          } @default {
          <a
            class="small-banner-img-container"
            [owlRouterLink]="['/products']"
            [queryParams]="{
              collection_ids: _banner.click_action.value,
              utm_source: 'home',
              utm_medium: 'banner'
            }"
            [stopLink]="isDragging"
          >
            <webstore-horizontal-banner [bannerInput]="_banner"></webstore-horizontal-banner>
          </a>
          } }
        </div>
      </ng-template>
      }
    </owl-carousel-o>

    <!-- Buttons only visible when banners length greater than one -->
    @if (banners && banners.length > 1) {
    <button
      class="prev-btn left-navigation"
      [class.small-banner-left-navigation]="isMultipleBanner"
      type="button"
      (click)="owlCar.prev()"
    >
      Prev
    </button>
    <button
      class="next-btn right-navigation"
      [class.small-banner-right-navigation]="isMultipleBanner"
      type="button"
      (click)="owlCar.next()"
    >
      Next
    </button>
    }
  </div>
</div>
